type FileEle = {
  name: string;
  highlight?: {
    name?: string[];
    fileContent?: string[];
  };
};

// 渲染文件名称
export function renderFileNameEle(item: FileEle): string {
  const { name, highlight } = item;
  if (highlight?.name) {
    const highlightEle = highlight?.name.join();
    let highlightHandle!: string;
    let highlightName!: string;
    try {
      highlightHandle = decodeURIComponent(highlightEle)
        .replace(/<em>/g, '<span class="highlight">')
        .replace(/<\/em>/g, '</span>');
      highlightName = decodeURIComponent(highlightEle).replace(/<em>|<\/em>/g, '');
    } catch (error) {
      highlightHandle = highlightEle.replace(/<em>/g, '<span class="highlight">').replace(/<\/em>/g, '</span>');
      highlightName = highlightEle.replace(/<em>|<\/em>/g, '');
    }
    // 由于后端对以下字符做了转义处理，所以需反转义
    highlightName = highlightName
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&apos;/g, "'");
    if (name.includes(highlightName)) {
      return highlightHandle;
    }
    return highlightEle;
  }
  return name;
}
// 渲染文件内容（因需要返回数组，目前先单独处理了）
export function renderFileContentEle(item: FileEle): string[] {
  const { highlight } = item;
  const highlightConetntArray = [];
  if (highlight?.fileContent) {
    const highlightEleArray = highlight?.fileContent;
    // 最多只展示4段内容
    const highlightEleLength = Math.min(highlightEleArray.length, 4);
    for (let i = 0; i < highlightEleLength; i++) {
      let highlightHandle!: string;
      try {
        highlightHandle = decodeURIComponent(highlightEleArray[i])
          .replace(/<em>/g, '<span class="highlight">')
          .replace(/<\/em>/g, '</span>');
      } catch (error) {
        highlightHandle = highlightEleArray[i]
          .replace(/<em>/g, '<span class="highlight">')
          .replace(/<\/em>/g, '</span>');
      }
      highlightConetntArray[i] = highlightHandle;
    }
  }
  return highlightConetntArray;
}
